(function ($) {
    $(function () {
        
        $('.fast_forward').click(function (event) {

            var a_id = (this.id).split("_");
            var ele = a_id[1];
            var audioElm = document.getElementById("audio_"+ele); // Get audio element

            if(audioElm.readyState==4) {
                audioElm.currentTime = audioElm.currentTime + 5;

                if (audioElm.pause() !== 'undefined') {
                    audioElm.play();
                }
            }
            event.preventDefault();
            return false;
        });
    });
})(jQuery);
